/* eslint-disable global-require, no-underscore-dangle, no-shadow */
import React from 'react'
import ReactGA from 'react-ga'
import ReactDOM from 'react-dom'
import Helmet from 'react-helmet'
import { Provider } from 'react-redux'
import { renderToStaticMarkup } from 'react-dom/server'
import { syncHistoryWithStore } from 'react-router-redux'
import useScroll from 'react-router-scroll/lib/useScroll'
import {
  Router,
  match,
  RouterContext,
  browserHistory,
  applyRouterMiddleware
} from 'react-router'
import 'airbnb-js-shims'
import routes from './routes'
import { configureAxios } from './axios'
import { configureStore } from './store'
import Root from './containers/Root'

require('es6-promise').polyfill()

function logPageView() {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.set({ page: window.location.pathname })
    ReactGA.pageview(window.location.pathname)
  }
}

if (typeof document !== 'undefined') {
  require('./styles/reboot.css')
  require('./styles/grid.css')
  require('./styles/fontawesome.css')
  require('./styles/slick.css')
  require('react-dates/lib/css/_datepicker.css')
  require('./styles/index.css')
  require('smoothscroll-polyfill').polyfill()

  configureAxios()
  const store = configureStore(window.__INITIAL_STATE__)
  const history = syncHistoryWithStore(browserHistory, store)
  ReactGA.initialize(process.env.GA_TRACKING_ID)

  ReactDOM.render(
    <Provider store={store}>
      <Router
        routes={routes}
        history={history}
        onUpdate={logPageView}
        render={applyRouterMiddleware(useScroll())}
      />
    </Provider>,
    document.getElementById('root')
  )
}

function renderRootComponent(Component, componentProps, store) {
  const html = renderToStaticMarkup(
    <Provider store={store}>
      <Component {...componentProps} />
    </Provider>
  )

  const head = Helmet.rewind()
  const initialState = store.getState()
  return `<!doctype html>
    ${renderToStaticMarkup(
      <Root head={head} html={html} initialState={initialState} />
    )}`
}

const handleError = (res, error) => res.status(500).send(error.message)

const handleRedirect = (res, redirectLocation) => {
  res.redirect(302, redirectLocation.pathname + redirectLocation.search)
}

const routeIsUnmatched = (renderProps) =>
  renderProps.routes[renderProps.routes.length - 1].path === '*'

function handleRoute(res, renderProps) {
  const store = configureStore()
  const status = routeIsUnmatched(renderProps) ? 404 : 200
  const readyOnAllActions = renderProps.components
    .filter((component) => component.readyOnActions)
    .map((component) =>
      component.readyOnActions(store.dispatch, renderProps.params)
    )

  Promise.all(readyOnAllActions).then(() =>
    res
      .status(status)
      .send(renderRootComponent(RouterContext, renderProps, store))
  )
}

export function serverMiddleware(req, res) {
  match(
    { routes, location: req.url },
    (error, redirectLocation, renderProps) => {
      if (error) {
        handleError(error)
      } else if (redirectLocation) {
        handleRedirect(res, redirectLocation)
      } else if (renderProps) {
        handleRoute(res, renderProps)
      } else {
        res.sendStatus(404)
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/index.js